import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";

export function useListDocumentsByOrg(category: SourceOrgCategory, orgId: string) {
  return useQuery({
    queryKey: ["listDocumentsByOrg", category, orgId],
    queryFn: () => api.listDocumentsByOrg(category, orgId),
    refetchInterval: 5000,
  });
}
